import React from 'react';
import { createPortal } from 'react-dom';
import PropTypes from 'prop-types';

const propTypes = {
  children: PropTypes.any.isRequired
};

class LeftPanelPortal extends React.Component {
  constructor() {
    super();
    this.node = null;
  }

  componentDidMount() {
    this.node = document.getElementById('subnav-portal');
    if(this.node) this.forceUpdate();
  }

  render() {
    const { children } = this.props;

    if(!this.node) return null;
    return createPortal(children, this.node);
  }
}

LeftPanelPortal.propTypes = propTypes;

export default LeftPanelPortal;


// WEBPACK FOOTER //
// ./src/components/SubnavPortal.jsx